export default "__VITE_ASSET__4NkDcRmc__"